import { createContext, useContext, useState, useCallback } from 'react';

const CompareContext = createContext(null);
const MAX_COMPARE = 3;

export function CompareProvider({ children }) {
  const [compareItems, setCompareItems] = useState([]);

  const addToCompare = useCallback((product) => {
    setCompareItems(prev => {
      if (prev.find(p => p.sku === product.sku)) return prev;
      if (prev.length >= MAX_COMPARE) return prev;
      return [...prev, product];
    });
  }, []);

  const removeFromCompare = useCallback((sku) => {
    setCompareItems(prev => prev.filter(p => p.sku !== sku));
  }, []);

  const clearCompare = useCallback(() => {
    setCompareItems([]);
  }, []);

  const isInCompare = useCallback((sku) => {
    return compareItems.some(p => p.sku === sku);
  }, [compareItems]);

  const canAdd = compareItems.length < MAX_COMPARE;

  return (
    <CompareContext.Provider value={{ compareItems, addToCompare, removeFromCompare, clearCompare, isInCompare, canAdd, MAX_COMPARE }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const ctx = useContext(CompareContext);
  if (!ctx) throw new Error('useCompare must be used within CompareProvider');
  return ctx;
}
